export const SET_RECOMMANDATION = 'SET_RECOMMANDATION';
export const SET_FILTER_RAYON = 'SET_FILTER_RAYON';
export const SET_CONCURRENTS = 'SET_CONCURRENTS';
export const SET_NBRE_CONCURRENTS = 'SET_NBRE_CONCURRENTS';
export const SET_HASH = 'SET_HASH';
export const SET_ICON_MARKER_PDV = 'SET_ICON_MARKER_PDV';
